import deepmerge from 'deepmerge';
import { FragmentConfig } from '@/config/types';
import config from './default';
import { DeepPartial } from './deeppartial';

export const tenantConfig: DeepPartial<FragmentConfig> = {
  apiParams: {
    values: {
      apiDefaultParams: {
        channel: 'web',
        clientId: 'UniversalAt',
        clientShortId: 'uvs',
        locale: 'de-AT',
        localeApi: 'de',
        localesToSwitch: ['de-AT'],
        useNewApi: true,
      },
      apiAssetManagement: {
        path: 'https://media.universal.at',
      },
    },
  },
};

export default deepmerge(config, tenantConfig) as FragmentConfig;
